export const BANGALORE_AREAS = [
    'BTM Layout',
    'Banashankari',
    'Banaswadi',
    'Bannerghatta Road',
    'Basavanagudi',
    'Basaveshwara Nagar',
    'Benson Town',
    'Bellandur',
    'Bommanahalli',
    'Bommasandra',
    'Brookefield',
    'CV Raman Nagar',
    'Domlur',
    'Electronic City Phase 1',
    'Electronic City Phase 2',
    'Frazer Town',
    'HBR Layout',
    'HSR Layout',
    'Hebbal',
    'Hennur',
    'Horamavu',
    'Indiranagar',
    'JP Nagar',
    'Jayanagar',
    'Kaggadasapura',
    'Kalyan Nagar',
    'Kammanahalli',
    'Kanakapura Road',
    'Kengeri',
    'Koramangala',
    'KR Puram',
    'Kumaraswamy Layout',
    'Mahadevapura',
    'Malleshwaram',
    'Marathahalli',
    'Mathikere',
    'Malleswaram',
    'MG Road',
    'Mysore Road',
    'Nagarbhavi',
    'Nagawara',
    'New Thippasandra',
    'Padmanabhanagar',
    'Peenya',
    'RT Nagar',
    'Rajajinagar',
    'Rajarajeshwari Nagar',
    'Richmond Town',
    'Sadashivanagar',
    'Sahakara Nagar',
    'Sarjapur Road',
    'Shanthi Nagar',
    'Shivajinagar',
    'Ulsoor',
    'Uttarahalli',
    'Vasanth Nagar',
    'Vidyaranyapura',
    'Vijayanagar',
    'Whitefield',
    'Yelahanka',
    'Yeshwanthpur',
];
